import startCase from 'lodash.startcase';

const definedPostalCodes = [
  {
    countryCode: 'CA',
    validationRegex: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
  },
  {
    countryCode: 'US',
    validationRegex: /^\d{5}(?:-\d{4})?$/,
  },
];

export const cardCodeToWording = (value) => {
  const code = value === 'master' ? 'master card' : value;
  return startCase(code);
};

export const formatPaymentFormValues = (values) => {
  const { email, ...billingInfo } = values;
  return {
    email,
    billing_info: {
      vatNumber: '', // Allow VAT ID removal for user
      ...billingInfo,
    },
  };
};

export const getPostalCodeValidationRegexFor = (countryCode) => (
  definedPostalCodes
    .find((definedPostalCodesRegex) => definedPostalCodesRegex.countryCode === countryCode)
);

/*
  This function assembles the billing info parameters.
  If there's a token specified, we just send that.
  Otherwise, we send all the billing information.
*/
export const getBillingInfoParams = (token, billingInfo) => {
  if (token) {
    return { token_id: token };
  }

  return {
    first_name: billingInfo.firstName,
    last_name: billingInfo.lastName,
    company: billingInfo.company,
    email: billingInfo.email,
    vat_number: billingInfo.vatNumber,
    address: {
      street1: billingInfo.address1,
      street2: billingInfo.address2,
      city: billingInfo.city,
      country: billingInfo.country,
      region: billingInfo.state,
      postal_code: billingInfo.postalCode,
    },
  };
};

export const getAccountParams = (token, formValues, threeDsTokenId) => ({
  billing_info: {
    ...getBillingInfoParams(token, formValues.billing_info),
    ...threeDsTokenId && { three_d_secure_action_result_token_id: threeDsTokenId },
  },
  // First name and last name might not be provided during the 3DS auth
  ...formValues.firstName && { first_name: formValues.firstName },
  ...formValues.lastName && { last_name: formValues.lastName },
  ...formValues.email && { email: formValues.email },
});
